module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"navUserMenu.title":"User Menu","navUserMenu.changePassword":"Change Password","navUserMenu.logOut":"Log Out"}}')
  delete Component.options._Ctor
}
